import React, { useState, useEffect } from "react";
import Data from "../App";
import { map, distinctUntilChanged } from "rxjs/operators";

const UiBindingView = ({ binding }) => {
  return (
    <div className="BindingRow">
      <div className="BindingAttribute">{binding.get("attribute")}</div>
      <div className="BindingCases">
        {binding.get("cases").map((aCase, index) => (
          <div key={index} className="BindingCaseRow">
            <div className="BindingCase">{aCase.get("case")}</div>
            <div className="BindingCase">{aCase.get("case_value")}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default UiBindingView;



// WEBPACK FOOTER //
// ./src/components/UiBindingView.js